/**
 * Extracts the base SIP URI from a string.
 */
export const extractSipUri = (
  uri: string | null | undefined
): string | null => {
  if (!uri) {
    return uri === '' ? '' : null;
  }

  // First try to extract URI from angle brackets if present
  const angleRegex = /<(sip:[^>]{0,500})>/i;
  const angleMatch = angleRegex.exec(uri);
  const sipUri = angleMatch ? angleMatch[1] : uri;

  // Then extract the base URI without parameters
  const baseRegex = /^(sip:[^;>]{0,500})/i;
  const baseMatch = baseRegex.exec(sipUri);
  return baseMatch ? baseMatch[1].toLowerCase() : sipUri.toLowerCase();
};

/**
 * Checks if a SIP URI has the SVRS-RT prefix.
 */
export const hasSvrsRtPrefix = (uri: string | null | undefined): boolean => {
  if (!uri) {
    return false;
  }

  const baseUri = extractSipUri(uri);
  if (!baseUri) {
    return false;
  }

  const match = baseUri.match(/^sip:([^@]+)@/i);
  if (!match) {
    return false;
  }

  const user = match[1];
  return user.startsWith('svrs-rt-');
};
